module.exports = __webpack_public_path__ + "static/assets/f46267f022facb696cc306921286c74e.png";